import React from 'react';
import TListing from '../../types/TListing';
import HorizontalScrollList from '../HorizontalScrollList';
import Listing from '../Listing';
import Classes from './ListingsList.module.scss';
import ListingSkeleton from '../Listing/ListingSkeleton';
import VerticalScrollList from '../VerticalScrollList';

const DEFAULT_SKELETON_COUNT = 10;

type TProps = {
  listings: TListing[];
  isLoading: boolean;
  onClickListing?: () => void;
  skeletonCount?: number;
  skeletonKey: string; // needed to identify a unique key for each skeleton item
  visualization?: 'carousel' | 'grid';
};

const ListingsList = ({
  listings,
  isLoading,
  onClickListing = () => null,
  skeletonCount = DEFAULT_SKELETON_COUNT,
  skeletonKey,
  visualization = 'carousel',
}: TProps) => {
  const ScrollList = visualization === 'grid' ? VerticalScrollList : HorizontalScrollList;

  return (
    <ScrollList.List>
      {isLoading &&
        Array(skeletonCount)
          .fill('')
          .map((_, i) => (
            <ScrollList.ListItem className={Classes.listingWrapper} key={`listings-skeleton-${skeletonKey}-${i}`}>
              <ListingSkeleton />
            </ScrollList.ListItem>
          ))}
      {!isLoading &&
        listings.map((listing, i) => (
          <ScrollList.ListItem className={Classes.listingWrapper} key={`listings-list-${listing.itemId}-${i}`}>
            <Listing listing={listing} onClick={onClickListing} />
          </ScrollList.ListItem>
        ))}
    </ScrollList.List>
  );
};

export default ListingsList;
